module.exports = __webpack_public_path__ + "static/media/PA.7f1dc8c4.jpg";